module.exports = __webpack_public_path__ + "img/plus-inactive.32241782.svg";